import netlifyIdentity from "netlify-identity-widget";
import "./src/styles/global.scss";

const identityTokenHashes = [
	"#invite_token=",
	"#recovery_token=",
	"#confirmation_token=",
];

const hasIdentityToken = (hash: string): boolean =>
	identityTokenHashes.some((tokenHash) => hash.startsWith(tokenHash));

const isExternalLink = (anchor: HTMLAnchorElement): boolean => {
	const rawHref = anchor.getAttribute("href");

	if (!rawHref) {
		return false;
	}

	// Anker, mailto:, tel: und relative Links bleiben unangetastet.
	if (!/^https?:\/\//i.test(rawHref)) {
		return false;
	}

	return anchor.hostname !== window.location.hostname;
};

const markExternalLinks = (root: ParentNode = document): void => {
	const anchors = root.querySelectorAll<HTMLAnchorElement>("a[href]");

	anchors.forEach((anchor) => {
		if (anchor.target || !isExternalLink(anchor)) {
			return;
		}

		anchor.target = "_blank";

		const rel = new Set(
			(anchor.getAttribute("rel") ?? "").split(/\s+/).filter(Boolean),
		);
		rel.add("noopener");
		rel.add("noreferrer");
		anchor.setAttribute("rel", Array.from(rel).join(" "));
	});
};

const observeExternalLinks = (): void => {
	markExternalLinks();

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof HTMLElement)) {
					return;
				}

				if (node instanceof HTMLAnchorElement) {
					markExternalLinks(node.parentNode ?? document);
					return;
				}

				markExternalLinks(node);
			});
		});
	});

	observer.observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
};

export const onRouteUpdate = (): void => {
	markExternalLinks();
};

export const onClientEntry = (): void => {
	netlifyIdentity.init();

	netlifyIdentity.on("login", () => {
		netlifyIdentity.close();
		window.location.assign("/admin/");
	});

	if (hasIdentityToken(window.location.hash)) {
		netlifyIdentity.open();
	}

	observeExternalLinks();
};
